import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import React, { useCallback, useMemo } from 'react';

import { Card } from '../../../components/Card';
import { useOfferContext } from '../../../context';
import { AgentContainer } from '../AgentContainer';
import { ControlsContainer } from '../ControlsContainer';
import { GalleryContainer } from '../GalleryContainer';
import { OfferGeneralInfoContainer } from '../OfferGeneralInfoContainer';
import { PessimizationTogglerContainer } from '../PessimizationTogglerContainer';
import { getMortgageType } from '../PriceContainer/utils';
import { ThumbnailsContainer } from '../ThumbnailsContainer';
import { VASContainer } from '../VAS/VASContainer';
import { getTermsValue } from 'shared/json_query/reducers/helpers';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { isCianPartner as isCianPartnerUtil } from 'shared/utils/dailyrent/isCianPartner';

export function OfferCardContainer() {
  const { config } = useApplicationContext();

  const isNewHighlighting = config.get<boolean>('new_highlighting') || false;

  const {
    isColored,
    offer,
    jsonQuery,
    api: { isPopupsOpened, onPageJumped },
    kp,
    tracking,
    mortgageBanner,
    isNewbuilding,
  } = useOfferContext();

  const { fullUrl, externalOfferUrl, showGalleryThumbnails, dailyrent } = offer;

  const isCianPartner = isCianPartnerUtil(offer);

  // Получаем выбранные типы ипотеки из фильтров
  const promoSearchTypes = getTermsValue('promo_search_types')(jsonQuery);
  const mortgageType = getMortgageType(promoSearchTypes);

  // Формируем href с учетом типа ипотеки
  const href = useMemo(() => {
    const baseUrl = isCianPartner ? externalOfferUrl : fullUrl;

    if (!mortgageType || isCianPartner) {
      return baseUrl;
    }

    // Проверяем, есть ли уже query параметры в URL
    const hasQueryParams = baseUrl.includes('?');
    const separator = hasQueryParams ? '&' : '?';

    return `${baseUrl}${separator}mortgage_type=${mortgageType}`;
  }, [isCianPartner, externalOfferUrl, fullUrl, mortgageType]);

  const rel = isCianPartner ? 'noreferrer nofollow noindex' : 'noreferrer';

  const handleCardClick = useCallback(() => {
    if (isPopupsOpened()) {
      return;
    }
    onPageJumped('card_detail_in_newlist');
  }, [isPopupsOpened, onPageJumped]);

  const onAfterViewedHandle = () => tracking.trackOfferCardShow();

  return (
    <ActionAfterViewObserver percentVisible={0.5} callback={onAfterViewedHandle} triggerOnce callbackDelay={1000}>
      <Card
        href={href}
        onClick={handleCardClick}
        isWide={showGalleryThumbnails || Boolean(kp?.villageAdvantages) || isNewbuilding}
        colored={!isNewHighlighting && isColored}
        gallery={<GalleryContainer />}
        thumbnails={<ThumbnailsContainer />}
        content={<OfferGeneralInfoContainer isNewHighlighting={isNewHighlighting} mortgageBanner={mortgageBanner} />}
        agent={<AgentContainer />}
        controls={<ControlsContainer />}
        showVas={!dailyrent?.hotelData?.isHotel}
        vas={<VASContainer />}
        pessimization={<PessimizationTogglerContainer />}
        comment={null}
        rel={rel}
      />
    </ActionAfterViewObserver>
  );
}
